import MyModal from '@/components/my-modal';
import { groupsApis } from '@/configs/apis/groups';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import type {
  ChatGroupParams,
  ChatGroupSettingsParams,
} from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { useChatContext } from '@/contexts/chat/context';
import styles from './index.module.scss';
import DefaultAvatarIcon from './images/default-avatar-icon.svg?react';

export default function GroupHeaderEditModal({
  open,
  value,
  chat,
  onCancel,
  insertSettings,
  updateGroups,
}: {
  open: boolean;
  value: string;
  chat: Chat;
  onCancel: () => void;
  insertSettings: (params: ChatGroupSettingsParams[]) => Promise<void>;
  updateGroups: (params: ChatGroupParams[]) => Promise<void>;
}) {
  const [name, setName] = useState(value);
  const { updateChats } = useChatContext();

  const canClickAction = useMemo(() => {
    return name.trim() !== '';
  }, [name]);

  const handleDone = async () => {
    onCancel();
    await groupsApis.updateGroupInfo({
      gid: chat.chat_id,
      group_name: name,
    });
    await insertSettings([{ group_id: chat.chat_id, group_name: name }]);
    await updateGroups([{ group_id: chat.chat_id, name }]);
    await updateChats([{ chat_id: chat.chat_id, name }]);
  };

  useEffect(() => {
    if (open) {
      setName(chat.name);
    }
  }, [chat.name, open]);

  return (
    <MyModal
      title="Edit Group"
      open={open}
      cancelText="Cancel"
      onCancel={onCancel}
      canClickAction={canClickAction}
      actionText="Save"
      onAction={handleDone}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.avatar}>
            <DefaultAvatarIcon />
          </div>
          <div className={styles.avatarText}>Add Photo</div>
        </div>
        <Input value={name} onChange={(e) => setName(e.target.value)} />
      </div>
    </MyModal>
  );
}
